import { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import SideTabs from '@/components/SideTabs';
import Home from '@/pages/Home';
import LoadingSpinner from '@/components/LoadingSpinner';

// Home se carga junto al bundle principal para que el recorrido virtual del banner
// empiece a descargarse lo antes posible; el resto de las páginas sigue con lazy loading
const QuienesSomos = lazy(() => import('@/pages/QuienesSomos'));
const Documentos = lazy(() => import('@/pages/Documentos'));
const Becas = lazy(() => import('@/pages/Becas'));
const ListaDeUtiles = lazy(() => import('@/pages/ListaDeUtiles'));
const Galeria = lazy(() => import('@/pages/Galeria'));
const Admision = lazy(() => import('@/pages/Admision'));

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <SideTabs />
        <main className="flex-grow">
          <Suspense 
            fallback={
              <div className="flex justify-center items-center min-h-[50vh]">
                <LoadingSpinner size="large" />
              </div>
            }
          >
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/quienes-somos" element={<QuienesSomos />} />
              <Route path="/documentos" element={<Documentos />} />
              <Route path="/lista-de-utiles" element={<ListaDeUtiles />} />
              <Route path="/galeria" element={<Galeria />} />
              <Route path="/becas" element={<Becas />} />
              <Route path="/admision" element={<Admision />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;